import { URL_CDN } from "src/constants/path";
import { truncateString } from "src/utils/helper";

export const mapIconToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const iconColumns = [
  {
    key: "pathname",
    label: "Image",
    align: "center",
    render: (item) => (
      <img
        style={{ width: "50px", height: "50px" }}
        src={`${URL_CDN}/${item.pathname}`}
        alt={item.title}
      />
    ),
  },
  { key: "deviceName", label: "Device Name", align: "center" },
  { key: "iconType", label: "Icon type", align: "center" },
  {
    key: "link",
    label: "Image",
    align: "center",
    render: (item) => (
      <a target="_blank" href={`${URL_CDN}/${item.pathname}`} rel="noreferrer">
        {truncateString(`${URL_CDN}/${item.pathname}`, 50)}
      </a>
    ),
  },
];
